import { ShippingCollection } from 'src/types';

export enum ShippingType {
  CHEAPEST = 'cheapestThenFastest',
  FASTEST = 'fastestThenCheapest',
}

export const getDeliveryDays = (
  shippingCollection: ShippingCollection,
  type: ShippingType
) => {
  if (!shippingCollection || !shippingCollection[type]?.length) {
    return null;
  }
  const [selectedShipping] = shippingCollection[type];
  if (
    !selectedShipping.deliveryDays ||
    selectedShipping.deliveryDays.min < 0 ||
    selectedShipping.deliveryDays.max < 0
  ) {
    return null;
  }
  const from = selectedShipping.deliveryDays.min;
  const to = selectedShipping.deliveryDays.max;
  return from + to === 0 ? '0' : `${from}-${to}`;
};
